import { render, staticRenderFns } from "./NotAuthView.vue?vue&type=template&id=05d11ee5"
import script from "./NotAuthView.vue?vue&type=script&lang=ts"
export * from "./NotAuthView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports